// frontend/src/pages/mind-mesch/Docs.js

import React from 'react';
import MindMeschLayout from '../../components/mind-mesch/MindMeschLayout';

const Docs = () => {
  return (
    <MindMeschLayout>
      <section className="docs-section">
        <h1>Mind Mesch API Documentation</h1>

        <div className="api-endpoint">
          <h2>POST /api/memory/ingest-memory</h2>
          <p><strong>Description:</strong> Save a new memory with context enrichment (emotion, tone, intent).</p>
          <p><strong>URL:</strong> <code>https://whale-app-efzv4.ondigitalocean.app/api/memory/ingest-memory</code></p>

          <h4>Headers</h4>
          <pre>{`PARTNER_API_KEY: your-partner-key
Content-Type: application/json`}</pre>

          <h4>Body</h4>
          <pre>{`{
  "origin": "rewind",
  "externalUserId": "rewind-user-001",
  "content": "Today I walked in nature and felt peaceful.",
  "timestamp": "2025-05-05T15:00:00Z"
}`}</pre>

          <h4>Response</h4>
          <pre>{`{
  "memoryId": "abc123",
  "summary": "Summary of: Today I walked in nature...",
  "intent": "reflection",
  "emotion": "calm",
  "tone": "peaceful",
  "timestamp": "2025-05-05T15:00:00Z"
}`}</pre>
        </div>

        <div className="api-endpoint">
          <h2>POST /api/usage-summary</h2>
          <p><strong>Description:</strong> Returns memory usage stats by partner or external user.</p>
          <p><strong>URL:</strong> <code>https://whale-app-efzv4.ondigitalocean.app/api/usage-summary</code></p>

          <h4>Headers</h4>
          <pre>{`PARTNER_API_KEY: your-partner-key
Content-Type: application/json`}</pre>

          <h4>Body</h4>
          <pre>{`{
  "origin": "rewind",
  "externalUserId": "rewind-user-001" // optional
}`}</pre>

          <h4>Response</h4>
          <pre>{`{
  "origin": "rewind",
  "externalUserId": "rewind-user-001",
  "totalUsers": 1,
  "totalMemories": 42,
  "mostRecent": "2025-05-05T04:02:47.505Z"
}`}</pre>
        </div>

        <div className="api-endpoint">
          <h2>POST /api/memory/query</h2>
          <p><strong>Description:</strong> Retrieve most recent memories (optionally filtered by intent).</p>
          <p><strong>URL:</strong> <code>https://whale-app-efzv4.ondigitalocean.app/api/memory/query</code></p>

          <h4>Headers</h4>
          <pre>{`PARTNER_API_KEY: your-partner-key
Content-Type: application/json`}</pre>

          <h4>Body</h4>
          <pre>{`{
  "origin": "rewind",
  "externalUserId": "rewind-user-001",
  "limit": 10,
  "intent": "reflection" // optional
}`}</pre>

          <h4>Response</h4>
          <pre>{`{
  "origin": "rewind",
  "externalUserId": "rewind-user-001",
  "limit": 10,
  "intent": "reflection",
  "count": 2,
  "results": [ ... ]
}`}</pre>
        </div>
      </section>
    </MindMeschLayout>
  );
};

export default Docs;
